import {
  TextField,
  Box,
  Checkbox,
  FormLabel,
  useTheme,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Breadcrumbs,
  LinearProgress,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Chip,
  MenuItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
} from "@mui/material";
import dayjs from "dayjs";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import axios from "axios";
import store from "../../..";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import CloseIcon from "@mui/icons-material/Close";

import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import {
  postData,
  ProjectEnquiryGet,
  resetTrackingData,
  sprintGetData,
  sprintprojectplanGetData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { tokens } from "../../../Theme";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridActionsCellItem,
  GridRowModes,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import { Formik, Field } from "formik";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Mode } from "@mui/icons-material";
import ExcelUpload from "../../../ui-components/ExcelUpload";
import { FaFileExcel } from "react-icons/fa";
import ProjectEnquiryExcel from "../../reports/ProjectEnquiryExcel";



const EditProjectEnquiry = (empId, appId) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  console.log(params, "--params");

  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const ProjEnqGET = useSelector((state) => state.formApi.ProjEnqGET) || [];
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);

  const YearFlag = sessionStorage.getItem("YearFlag");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const CompanyID = sessionStorage.getItem("companyId");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const EMPID = sessionStorage.getItem("EmpId");
  const location = useLocation();
  const state = location.state || {};
  const [pageSize, setPageSize] = React.useState(15);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [showMore, setShowMore] = useState(false);
  const [errorMsgData, setErrorMsgData] = useState(null);

  // useEffect(() => {
  //   fetch(process.env.PUBLIC_URL + "/validationcms.json")
  //     .then((res) => {
  //       if (!res.ok) throw new Error("Failed to fetch validationcms.json");
  //       return res.json();
  //     })
  //     .then((data) => {
  //       setErrorMsgData(data);
  //     })
  //     .catch((err) => console.error("Error loading validationcms.json:", err));
  // }, []);
  useEffect(() => {
    // Get session values
    const savedProData = sessionStorage.getItem("selectedPro");
    const savedmileData = sessionStorage.getItem("selectedmiles");
    const savedActData = sessionStorage.getItem("selectedAct");
    const savedOSData = sessionStorage.getItem("selectedOS");

    const pro = savedProData ? JSON.parse(savedProData) : [];
    const Act = savedActData ? JSON.parse(savedActData) : [];
    const OS = savedOSData ? JSON.parse(savedOSData) : [];
    const mile = savedmileData ? JSON.parse(savedmileData) : [];

    setSelectedPro(pro);
    setSelectedAct(Act);
    setSelectedOS(OS);
    setSelectedMiles(mile);

  }, []);
  // useEffect(() => {
  //   GetSprintData();
  //   var url = store.getState().globalurl.empGetAttachmentUrl;
  //   axios
  //     .get(url, {
  //       params: {
  //         empId: EMPID,
  //         appId: recID,
  //       },
  //     })
  //     .then((response) => {
  //       setFiles(response.data);
  //     })
  //     .catch((err) => {
  //       setError("Failed to fetch attachments.");
  //       console.error(err);
  //     })
  //     .finally(() => setLoading(false));
  // }, [location.key]);

  // async function GetSprintData() {
  //   const data = await dispatch(sprintGetData({ SprintHeaderID: recID }));
  //   if (data.payload.Status == "Y") {
  //     const resData = data.payload.Data.detailData.map((value) => {
  //       return {
  //         ...value,
  //         ScheduledTo: {
  //           RecordID: value.ScheduledTo,
  //           Name: value.EmployeeName,
  //         },
  //       };
  //     });
  //     setRows(resData);
  //   } else {
  //     setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
  //   }
  // }
  // *************** INITIALVALUE  *************** //
  const [rowModesModel, setRowModesModel] = useState({});
  const [funMode, setFunMode] = useState(mode);
  const [open, setOpen] = useState(false);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState(null);
  const [selectedScheduledToOptions, setSelectedScheduledToOptions] =
    useState(null);

  const [rows, setRows] = useState([]);
  const [selectedPro, setSelectedPro] = useState([]);
  const [selectedmiles, setSelectedMiles] = useState([]);
  const [selectedOS, setSelectedOS] = useState([]);
  const [selectedAct, setSelectedAct] = useState([]);

  const handleApply = async (values) => {

    const selectedStatus = values.Status
      ? values.Status
        .split(",")
        .map((s) => `'${s}'`)
        .join(",")
      : "";

    const fromDate = values.FromDate
      ? dayjs(values.FromDate).format("YYYY-MM-DD")
      : "";
    const toDate = values.ToDate
      ? dayjs(values.ToDate).format("YYYY-MM-DD")
      : "";
    if (
      values.taskdesc ||
      values.FromDate ||
      values.ToDate ||
      projectID ||
      milestoneID ||
      OprStagID ||
      ActvitID
    ) {
      const data = await dispatch(
        ProjectEnquiryGet({
          TaskDescription: values.taskdesc || "",
          FromDate: fromDate,
          ToDate: toDate,
          CompanyID: `(${CompanyID})` || "",
          ProjectID: projectID ? `(${projectID})` : "",
          MilestoneID: milestoneID ? `(${milestoneID})` : "",
          OperationStageID: OprStagID ? `(${OprStagID})` : "",
          ActivitesID: ActvitID ? `(${ActvitID})` : "",
          Status: selectedStatus ? `(${selectedStatus})` : "",
        })
      );
      if (data.payload.Status == "N") {
        toast.error(data.payload.Msg);
      }
    } else {
      toast.error("Please Choose Any one of the Filter");
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          //   navigate(-1);
          navigate("/Apps/Chart");
        }
      } else {
        return;
      }
    });
  };

  const [rowCount, setRowCount] = useState(0);
  function Custombar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Tasks</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const Sprintcolumns = [
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "RecordID",
      headerName: "RecordID",
      headerAlign: "center",
      align: "right",
      width: "5",
      hide: true,
    },
    {
      headerName: "Project",
      field: "Project",
      width: "160",
      headerAlign: "center",
      hide: false,
      editable: true,
    },
    {
      headerName: "Milestone",
      field: "Milestone",
      width: "160",
      headerAlign: "center",
      hide: false,
      editable: true,
    },
    {
      headerName: "Operation Stage",
      field: "OperationStage",
      width: "160",
      headerAlign: "center",
      hide: false,
      editable: true,
    },
    {
      headerName: "Activities",
      field: "Activites",
      width: "160",
      headerAlign: "center",
      hide: false,
      editable: true,
    },

    {
      headerName: "Task Date",
      field: "ProjectPlanDate",
      type: "date",
      width: "150",
      align: "center",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Task Description",
      field: "Task",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
{
      headerName: "Scheduled To",
      field: "ScheduledToName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Status",
      field: "Status",
      width: "160",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
  ];

  const projectID = selectedPro.map((proj) => proj.RecordID).join(",");
  const milestoneID = selectedmiles.map((miles) => miles.RecordID).join(",");
  const OprStagID = selectedOS.map((opstg) => opstg.RecordID).join(",");
  const ActvitID = selectedAct.map((actsid) => actsid.RecordID).join(",");

  const STATUS_LIST = [
    { label: "Completed", code: "C" },
    { label: "Approved", code: "AP" },
    { label: "Inprogress", code: "I" },
    { label: "Rejected", code: "RJ" },
    { label: "Assigned", code: "AS" },
    { label: "Scheduled", code: "SH" },
    { label: "Not Yet Started", code: "N" },
  ];


  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={1}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h3"
                color="black"
                sx={{ cursor: "default", marginLeft: "10px", fontSize: "19px",color: "#0000D1" }}
                onClick={() => navigate(-1)}
              >
                Project Enquiry
              </Typography>
            </Breadcrumbs>
          </Box>

          <Box display="flex">
            {/* <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={{
            taskdesc: sessionStorage.getItem("taskdesc") || "",
            FromDate: sessionStorage.getItem("FromDate") || "",
            ToDate: sessionStorage.getItem("ToDate") || "",
          }}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              handleApply(values, resetForm);
            }, 100);
          }}
          enableReinitialize={true}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                setSelectedPro([]);
                setSelectedMiles([]);
                setSelectedOS([]);
                setSelectedAct([]);
                sessionStorage.removeItem("selectedmiles")
                sessionStorage.removeItem("selectedOS")
                sessionStorage.removeItem("selectedAct")
                sessionStorage.removeItem("selectedPro")
                sessionStorage.removeItem("FromDate")
                sessionStorage.removeItem("ToDate")
                sessionStorage.removeItem("taskdesc")
                dispatch(resetTrackingData());
              }}
            >
              <Box
                display="grid"
                gap={formGap}
                padding={1}
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 2",
                  },
                }}
              >
                <TextField
                  name="taskdesc"
                  type="text"
                  id="taskdesc"
                  label="Task Description"
                  variant="standard"
                  focused
                  // required
                  value={values.taskdesc}
                  onBlur={handleBlur}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("taskdesc", e.target.value);
                  }}
                  // error={!!touched.taskdesc && !!errors.taskdesc}
                  // helperText={touched.taskdesc && errors.taskdesc}
                  autoFocus
                />

                <Box
                  display="flex"
                  justifyContent={"flex-end"}
                  padding={1}
                  gap={2}
                >
                  <Button
                    sx={{ color: "white", backgroundColor: "#2196f3" }}
                    // color="primary"
                    variant="contained"
                    // size="small"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {/* {showMore ? "Less" : "More"} */}
                    {showMore ? "More" : "More"}
                  </Button>
                </Box>
                <TextField
                  name="FromDate"
                  type="date"
                  id="FromDate"
                  label="From Date"
                  // label={
                  //     <>
                  //         From Date<span style={{ color: "red", fontSize: "20px" }}> * </span>
                  //     </>
                  // }
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  focused
                  value={values.FromDate}
                  onBlur={handleBlur}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("FromDate", e.target.value);
                  }}
                  error={!!touched.FromDate && !!errors.FromDate}
                  helperText={touched.FromDate && errors.FromDate}
                // required
                />
                <TextField
                  name="ToDate"
                  type="date"
                  id="ToDate"
                  label="To Date"
                  // label={
                  //     <>
                  //         To Date<span style={{ color: "red", fontSize: "20px" }}> * </span>
                  //     </>
                  // }
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  focused
                  value={values.ToDate}
                  onBlur={handleBlur}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("ToDate", e.target.value);
                  }}
                  error={!!touched.ToDate && !!errors.ToDate}
                  helperText={touched.ToDate && errors.ToDate}
                  // required

                  inputProps={{
                    min:
                      values.FromDate || new Date().toISOString().split("T")[0],
                  }}
                />
                {showMore && (
                  <>
                    <MultiFormikOptimizedAutocomplete
                      sx={{ width: "100%" }}
                      name="ProName"
                      label="Project"
                      id="ProName"
                      value={selectedPro || []}
                      onChange={(e, newValue) => {
                        setFieldValue("ProName", newValue);
                        setSelectedPro(newValue);
                        console.log(selectedPro, "--find RecordID");
                        if (newValue)
                          sessionStorage.setItem("selectedPro", JSON.stringify(newValue));
                        else
                          sessionStorage.removeItem("selectedPro");
                        //Lookup Clear if Project is cleared (empty array), clear all dependent lookups
                        if (!newValue || newValue.length === 0) {
                          setSelectedMiles([]);
                          setSelectedOS([]);
                          setSelectedAct([]);
                          setFieldValue("Milestone", []);
                          setFieldValue("OperationStage", []);
                          setFieldValue("Activities", []);
                          sessionStorage.removeItem("selectedmiles")
                          sessionStorage.removeItem("selectedOS")
                          sessionStorage.removeItem("selectedAct")
                        }
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID='${CompanyID}'","Any":""}}`}
                    />
                    <MultiFormikOptimizedAutocomplete
                      //   sx={{ marginTop: "7px" }}
                      name="Milestone"
                      label="Milestone"
                      variant="outlined"
                      id="Milestone"
                      value={selectedmiles}
                      getOptionLabel={(option) => option?.Name || ""}
                      onChange={(e, newValue) => {
                        setFieldValue("Milestone", newValue);
                        setSelectedMiles(newValue);
                        //Lookup Clear
                        if (newValue)
                          sessionStorage.setItem("selectedmiles", JSON.stringify(newValue));
                        else
                          sessionStorage.removeItem("selectedmiles");
                        if (!newValue || newValue.length === 0) {
                          setSelectedOS([]);
                          setSelectedAct([]);
                          setFieldValue("OperationStage", []);
                          setFieldValue("Activities", []);
                        }
                      }}
                      // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID='${selectedPro ? selectedPro.RecordID : 0}'","Any":""}}`}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${projectID}) AND CompanyID='${CompanyID}'","Any":""}}`}
                    />
                    <MultiFormikOptimizedAutocomplete
                      sx={{ marginTop: "7px" }}
                      name="OperationStage"
                      label="Operation Stage"
                      variant="outlined"
                      id="OperationStage"
                      value={selectedOS}
                      onChange={(e, newValue) => {
                        setFieldValue("OperationStage", newValue);
                        setSelectedOS(newValue);
                        if (newValue)
                          sessionStorage.setItem("selectedOS", JSON.stringify(newValue));
                        else
                          sessionStorage.removeItem("selectedOS");
                        if (!newValue || newValue.length === 0) {
                          setSelectedAct([]);
                          setFieldValue("Activities", []);
                        }
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID IN(${milestoneID})","Any":""}}`}
                    />

                    <MultiFormikOptimizedAutocomplete
                      sx={{ marginTop: "7px" }}
                      name="Activities"
                      label="Activities"
                      variant="outlined"
                      id="Activities"
                      value={selectedAct}
                      onChange={(e, newValue) => {
                        setFieldValue("Activities", newValue);
                        setSelectedAct(newValue);
                        if (newValue)
                          sessionStorage.setItem("selectedAct", JSON.stringify(newValue));
                        else
                          sessionStorage.removeItem("selectedAct");
                        console.log(newValue, "-- setSelectedAct newValue");
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID IN(${OprStagID})","Any":""}}`}
                    />

                    <FormControl
                      variant="standard"
                      sx={{ marginTop: "0px", minWidth: 160 }}
                      focused
                    >
                      <InputLabel id="Status-label">Status</InputLabel>

                      <Select
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 260,
                            },
                          },
                          MenuListProps: {
                            dense: true,          // ✅ THIS is critical
                            disablePadding: true // ✅ removes extra spacing
                          },
                        }}
                        labelId="Status-label"
                        id="Status"
                        name="Status"
                        multiple
                        value={values.Status ? values.Status.split(",") : []}
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: "Status",
                              value: e.target.value.join(","),
                            },
                          });
                        }}
                        renderValue={(selected) => (
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.4 }}>
                            {selected.map((code) => {
                              const status = STATUS_LIST.find((s) => s.code === code);
                              return (
                                <Chip
                                  key={code}
                                  label={status?.label || code}
                                  size="small"
                                  onMouseDown={(e) => e.stopPropagation()}
                                  onDelete={(e) => {
                                    e.stopPropagation();
                                    const updated = selected.filter((v) => v !== code);
                                    handleChange({
                                      target: {
                                        name: "Status",
                                        value: updated.join(","),
                                      },
                                    });
                                  }}
                                />
                              );
                            })}

                            {selected.length > 0 && (
                              <IconButton
                                sx={{ marginLeft: "10px" }}
                                size="small"
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChange({
                                    target: { name: "Status", value: "" },
                                  });
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Box>
                        )}
                      >
                        {STATUS_LIST.map(({ label, code }) => (
                          <MenuItem key={code} value={code}>
                            <Checkbox
                              checked={
                                values.Status
                                  ? values.Status.split(",").includes(code)
                                  : false
                              }
                            />
                            <ListItemText primary={label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>



                  </>
                )}
              </Box>
              <Box display="flex" justifyContent="end" padding={1} gap="20px">
                <Box display="flex" alignItems="center" gap={1}>
                  {/* <ExcelUpload
                    data={ProjEnqGET}
                    filename="Project - Enquiry.xlsx"
                  /> */}
   <FaFileExcel
                                        size={20}
                                        color="#1D6F42"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          ProjectEnquiryExcel(ProjEnqGET)
                                        }
                                      />

                </Box>
                <Button
                  color="secondary"
                  variant="contained"
                  type="submit"
                // loading={getLoading}
                // onClick={() => handleApply(values)}
                >
                  Apply
                </Button>
                {/* */}
                <Button
                  type="reset"
                  variant="contained"
                  color="error"
                  size="small"
                >
                  RESET
                </Button>
                {showMore && (
                  <Button
                    color="warning"
                    variant="contained"
                    // onClick={() => {
                    //   navigate("/Apps/ProjectEnquiry");
                    // }}
                    onClick={() => setShowMore(!showMore)}
                  >
                    Cancel
                  </Button>
                )}
                {/* //   } */}
              </Box>
              {/* {!getLoading ? ( */}
              <Box m="5px">
                <Box
                  m="5px 0 0 0"
                  height={"480px"}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#D3D3D3",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    //   rows={rows}

                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={ProjEnqGET}
                    columns={Sprintcolumns}
                    disableRowSelectionOnClick
                    loading={getLoading}
                    // rowModesModel={rowModesModel}
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    // components={{
                    //   Toolbar: AttendanceTool,
                    // }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    // editMode="cell"

                    // experimentalFeatures={{ newEditingApi: true }}
                    // onRowModesModelChange={handleRowModesModelChange}
                    // processRowUpdate={processRowUpdate}
                    // onProcessRowUpdateError={handleProcessRowUpdateError}
                    // onStateChange={(stateParams) =>
                    //   setRowCount(stateParams.pagination.rowCount)
                    // }
                    components={{
                      Toolbar: Custombar,
                    }}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    pagination
                  />
                </Box>
              </Box>
              {/* //   ) : (
            //     false
            //   )} */}
            </form>
          )}
        </Formik>
        <FileListPopup
          open={open}
          onClose={() => setOpen(false)}
          appId={recID}
          empId={EMPID}
        />
      </Paper>
    </React.Fragment>
  );
};

export default EditProjectEnquiry;
